exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".card {\n    box-shadow: 0px 1px 5px 1px rgba(0, 0, 0, 0.4);\n    min-height: 10.5em;\n    cursor: pointer;\n}\n\n.item-container:hover .card {\n    background-color: #ebebeb\n}\n\n.card img {\n    display: block;\n    margin: 0 auto;\n}\n\n.card-footer {\n    background-color: #75798c;\n    color: #ffffff;\n    border-top: 5px solid #68b0ff;\n}\n\n.item-container:hover .card-footer {\n    background-color: #484b5b;\n    color: #ffffff;\n}\n\n.text-title {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow:ellipsis;\n}\n\n.card-title {\n    color: #75798c;\n    font-weight: bold;\n    letter-spacing: 2px;\n}\n\n.corner-button-group {\n    position: absolute;\n    top: 1px;\n    right: 16px;\n    font-size: 0;\n    visibility: hidden;\n}\n\n.item-container:hover .corner-button-group {\n    visibility: visible;\n}\n\n.corner-button-group .list-inline-item {\n    font-size: 1em;\n    background-color: #f6f6f6;\n    margin: 0;\n    padding: 5px 5px;\n}\n\n.owner {\n  float: right;\n  font-size: 0.85em;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/project/project-list/project-list.component.css
// module id = 747
// module chunks = 0